// Modal reducer is used for showing & hiding modals, as well as passing data to modals. For a
// modal to be rendered, it must have a constant mapped to the component in constants/modalTypes.
//
// []component: constant representing component to be rendered
// []props: single object to be passed to modal component as props

import * as actionTypes from "../actions/actionTypes";
import { ModalTypes } from "@actions/useShowModal";

export default function modals(state = [], action) {
  if (action.type === actionTypes.SHOW_MODAL) {
    const newModal = {
      component: action.component,
      props: action.props,
    };
    return action.closeAll ? [newModal] : [...state, newModal];
  } else if (action.type === actionTypes.DISMISS_MODAL) {
    if (action.ofType === true) {
      return [];
    } else if (ModalTypes[action.ofType]) {
      return state.filter(modal => modal.component !== action.ofType);
    } else {
      return state.slice(0, -1);
    }
  }

  return state;
}
